export default __webpack_public_path__ + "static/media/uploadfile.9d88bf69.png";